import { useEffect } from "@wordpress/element";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import { useParams } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { getVariant } from "store/vino/productsSlice";
import Image from "vino/components/Image";
import { FormattedAmount, Button } from "vino/core";
import { TextField, NumberFormat, SelectField } from "vino/core/forms";
import {
	frequencyList,
	productSubscription,
	SubscriptionSchema,
} from "models/subscription";
import { setSubscription } from "store/vino/subscriptionSlice";

const Product = ({ onNext }) => {
	const dispatch = useDispatch();
	const variant = useSelector(({ vino }) => vino.products.variant);
	const subscription = useSelector(({ vino }) => vino.subscription.entity);
	const { variantId } = useParams();

	const methods = useForm({
		mode: "onChange",
		defaultValues: productSubscription,
		resolver: yupResolver(SubscriptionSchema),
	});
	const { handleSubmit, reset } = methods;

	useEffect(() => {
		dispatch(getVariant(variantId));
	}, [dispatch, variantId]);

	useEffect(() => {
		if (subscription.subscriptionProducts.length > 0) {
			reset(subscription);
		}
	}, [subscription, reset]);

	if (!variant) {
		return null;
	}

	const { product } = variant;

	const onSubmit = (model) => {
		const bottles = parseInt(model.bottles, 10);
		const variant = {
			variantId,
			quantity: bottles,
		};

		dispatch(
			setSubscription({
				...model,
				bottles,
				subscriptionProducts: [variant],
			})
		);
		onNext();
	};

	return (
		<Paper className="rounded-20 shadow mt-20 p-10">
			<FormProvider {...methods}>
				<form
					noValidate
					className="flex flex-col w-full"
					onSubmit={handleSubmit(onSubmit)}
				>
					<div className="flex w-full justify-between">
						<div className="w-1/2 p-5">
							<div className="flex justify-between mb-10">
								<Typography className="text-16 font-medium">
									Subscribe
								</Typography>
							</div>

							<div className="w-full flex flex-col px-20">
								<div className="mb-16 w-full">
									<TextField
										name="bottles"
										label="# Bottles"
										required
										fullWidth
										InputProps={{
											inputComponent: NumberFormat,
										}}
									/>
								</div>

								<div className="mb-16 w-full">
									<SelectField
										name="frequency"
										label="Deliver every"
										required
										fullWidth
									>
										{frequencyList.map((frequency) => (
											<MenuItem key={frequency.id} value={frequency.id}>
												{frequency.name}
											</MenuItem>
										))}
									</SelectField>
								</div>
							</div>
						</div>
						<div className="w-1/2">
							<div className="col w-full list-view-item p-5">
								<div className="card w-full shadow-sm mb-5">
									<div className="prodPic">
										<Image image={product} />
									</div>
									<div className="card-body px-10">
										<span className="dark list-item-title">{product.name}</span>
										<p className="card-text min-h-10">{product.description}</p>

										<div className="flex justify-content-between qrp-wrap pb-10">
											<div className="qr-details">
												<span className="prod-quantity">{variant.name}</span>
												<span className="prod-price">
													<FormattedAmount value={variant.price} />
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="flex w-full justify-end mb-20">
								<Button type="submit">
									Next <i className="fa-solid fa-angle-right ml-5"></i>
								</Button>
							</div>
						</div>
					</div>
				</form>
			</FormProvider>
		</Paper>
	);
};

export default Product;
